<template>
  <circle cx="18.5" cy="18.5" r="18.5" fill="#FFED00" />
  <path
    d="M18.5 22C20.433 22 22 20.433 22 18.5C22 16.5669 20.433 15 18.5 15C16.5669 15 15 16.5669 15 18.5C15 20.433 16.5669 22 18.5 22Z"
    stroke="#233F1F"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round" />
  <path
    d="M26.5035 16.8152L25.3509 14.032L26.9 12.2L24.8 10.1L22.9779 11.6571L20.1357 10.4882L19.4821 8H17.43L16.7666 10.5212L13.9896 11.6918L12.2 10.1L10.1 12.2L11.626 14.0783L10.4911 16.8686L8 17.45V19.55L10.5212 20.2383L11.6915 23.0147L10.1 24.8L12.2 26.9L14.0807 25.3673L16.8168 26.4929L17.45 29H19.55L20.1847 26.4939L22.9679 25.3413C23.4317 25.6729 24.8 26.9 24.8 26.9L26.9 24.8L25.3417 22.9619L26.4946 20.1779L28.9999 19.5261L29 17.45L26.5035 16.8152Z"
    stroke="#233F1F"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round" />
</template>
